import { Injectable } from '@angular/core';
import { BitmapWriter } from 'app/shared/rc/libs/_bmp/BitmapWriter';
import { GIFEncoder } from 'app/shared/rc/libs/_jsgif/GIFEncoder';
import { RcLoggerService } from './rcLoggerService';

export class CanvasImageBlob extends Blob {
    lastModifiedDate?: Date;
    name?: string;
}

@Injectable({providedIn: 'root'})
export class CanvasImageSaverService {
    constructor(/*private mcrcLog: RcLoggerService*/) {
    }

    private downloadFile = (href: string, fileName: string) => {
        const downloadLink: HTMLAnchorElement = document.createElement('a');
        downloadLink.href = href;
        if (fileName) {
            downloadLink.setAttribute('download', fileName);
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }

    private createBlob = (data: any, mimeType: string) => {
        if (typeof (Blob) === 'function' || typeof (Blob) === 'object') {
            data = new Uint8Array(data);
            return new Blob([data], { 'type': mimeType });
        }
        else throw new Error('Blob is not supported');
    }

    private saveAsBlob = (blob: Blob, fileName: string, imageType: string) => {
        // this.mcrcLog.debug('Save as blob', blob);
        const objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
        // this.mcrcLog.debug('Downloading as object URL: ' + objectUrl);
        this.downloadFile(objectUrl, fileName + '.' + imageType);
    }

    private convertDataUrlToBlobAndSave = (dataUrl: string, fileName: string, imageType: string, fileObject: boolean): Blob | undefined => {
        // this.mcrcLog.debug('Data url: ' + dataUrl);
        // this.mcrcLog.debug('Changing to blob');
        const b64Data = dataUrl.substring(dataUrl.indexOf('base64,') + 7);
        const data = this.str2Bytes(atob(b64Data));
        const blob = this.createBlob(data, 'image/' + imageType);
        if (fileObject) {
            return blob;
        }
        this.saveAsBlob(blob, fileName, imageType);
    }

    private checkNameNotEmpty = (fileName: string) => {
        var result = true;

        if (fileName === "") {
            result = false;
        }

        return result;
    };

    private str2Bytes = (strData: string): any[] => {
        var bytes = new Array(strData.length);
        for (var i = 0; i < strData.length; i++) {
            bytes[i] = strData.charCodeAt(i);
        }
        return bytes;
    };


    public save(canvas: HTMLCanvasElement, fileName: string, imageType: string, bpp: number, qualityPercentage: number, fileObject?: boolean): CanvasImageBlob | undefined {

        if (!this.checkNameNotEmpty(fileName)) {
            fileName = "screenshot";
        }

        // this.mcrcLog.debug('Save canvas image: type=' + imageType + ', bpp=' + bpp + ', quality=' + qualityPercentage);

        imageType = imageType.toLowerCase().replace('jpg', 'jpeg');
        if (!imageType.match(/png|jpeg|bmp|gif/)) throw new Error('Image format not implemented: ' + imageType);
        const quality: number = qualityPercentage > 0 ? (qualityPercentage / 100) : 0;
        let fileObj: CanvasImageBlob;
        switch (imageType) {
            case 'png':
                const dataUrl1 = canvas.toDataURL('image/png');
                fileObj = this.convertDataUrlToBlobAndSave(dataUrl1, fileName, imageType, fileObject);
                break;

            case 'jpeg':
                const dataUrl2 = canvas.toDataURL('image/jpeg', quality);
                fileObj = this.convertDataUrlToBlobAndSave(dataUrl2, fileName, imageType, fileObject);
                break;

            case 'bmp':
                const bmp = new BitmapWriter();
                const data = bmp.writeBMP(canvas, bpp);
                const blobBmp = this.createBlob(data, 'image/bmp');
                if (fileObject) {
                    fileObj = blobBmp;
                } else {
                    this.saveAsBlob(blobBmp, fileName, imageType);
                }
                break;

            case 'gif':
                const gifEncoder = new GIFEncoder();
                gifEncoder.start();
                gifEncoder.addFrame(canvas.getContext('2d'));
                gifEncoder.finish();
                const binData = this.str2Bytes(gifEncoder.stream().getData());
                const blobGif = this.createBlob(binData, 'image/gif');
                if (fileObject) {
                    fileObj = blobGif;
                } else {
                    this.saveAsBlob(blobGif, fileName, imageType);
                }
                break;

            default:
                throw new Error('Image type not supported: ' + imageType);
        }
        if (!fileObject) return undefined;

        fileObj.lastModifiedDate = new Date();
        fileObj.name = `${fileName}.${imageType}`;
        return fileObj;
    }
}
